import { navigate } from 'gatsby';
import React, { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle';
import { SideDrawer } from '@components/SideDrawer';

import * as ROUTES from '@constants/routes';

import { useIsMobile } from '@hooks/useIsMobile';

import AppLayout from '@layouts/AppLayout';

const messages = defineMessages({
  records: {
    id: 'recordsPage.records',
    defaultMessage: 'Records',
  },
});

export default function RecordsPage() {
  const mobile = useIsMobile();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (!mobile) {
      navigate(ROUTES.DASHBOARD);
    }
  }, [mobile]);

  return (
    <AppLayout>
      <MainTitle title={formatMessage(messages.records)} />
      <SideDrawer isOpen />
    </AppLayout>
  );
}
